import { style } from "@angular/animations";
import * as React from "react";
import useStyleClasses from "../polar-SAAS-Components/style";


interface FormData {
  username: string,
  currentPassword: string;
  password: string;
  confirmPassword: string;
}

interface ChangePasswordModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (formData) => void;
  error?: string;
  // isSubmitted?: boolean;
}

export default function ChangePasswordModal({
  open,
  onClose,
  onSubmit,
  error,
  // isSubmitted,
}: ChangePasswordModalProps) {
  const [formData, setFormData] = React.useState<FormData>({
    username: '',
    currentPassword: "",
    password: "",
    confirmPassword: ""
  });
  const [showPassword, setShowPassword] = React.useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false
  });
  const [errors, setErrors] = React.useState(
    {} as Partial<FormData>)
  if (!open) return null;
  const validate = (): boolean => {
    const newErrors: Partial<FormData> = {};

    if (!formData.currentPassword) newErrors.currentPassword = 'Current password is required';
    if (!formData.password) newErrors.password = 'New password is required';
    else if (
      !/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%&!?])/.test(formData.password)
    )
      newErrors.password =
        'Password must have uppercase, lowercase, number and special character';
    console.log('pattern invalid')

    if (!formData.confirmPassword) newErrors.confirmPassword = 'Confirm password is required';
    else if (formData.confirmPassword !== formData.password)
      newErrors.confirmPassword = 'Passwords do not match';

    setErrors(newErrors);
    console.log(newErrors)
    return Object.keys(newErrors).length === 0;
  };

  const styleClasses = useStyleClasses();
  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  const handleTogglePassword = field => {
    setShowPassword(prev => ({ ...prev, [field]: !prev[field] }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    let isvalid = validate();
    if (!isvalid) {
      console.log('form invalid', formData)
      return;
    }
    onSubmit(formData);
  };

  return (
    <div
      className="model-overlay"
      onClick={onClose}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        ...styleClasses.baseFont
      }}
    >
      <div
        className="model"
        onClick={(e) => e.stopPropagation()}
        style={{
          display: "flex",
          flexDirection: "column",
          maxHeight: "90vh",
          width: "700px",
          backgroundColor: "white",
          overflow: "hidden",
          ...styleClasses.baseFont
        }}
      >
        <div
          className="model-header"
          style={{
            flexShrink: 0,
            padding: "16px 24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2 className="model-title" style={styleClasses.formHeader}>
            Change Password
          </h2>
          <button
            className="close-btn"
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "24px",
              cursor: "pointer",
              ...styleClasses.baseFont
            }}
          >
            ×
          </button>
        </div>
                <div
          className="model-body"
          style={{
            overflowY: "auto",
            padding: "24px",
            flexGrow: 1,
            ...styleClasses.baseFont
          }}
        >
        {error && (
          <h6 color="error" style={{ marginBottom: "16px", color: "#ef4444" }}>
            {error}
          </h6>
        )}
        <form onSubmit={handleSubmit} autoComplete="off">
          <div className="form-group" style={{ paddingBottom: "0px" }}>
            <div style={{ flex: 1 }}>
              <label htmlFor="name" style={styleClasses.label}>
                Current Password <span style={{ color: "#ef4444" }}>*</span>
              </label>
              <input
                type="text"
                id="currentPassword"
                name="currentPassword"
                placeholder="Enter current password here"
                value={formData.currentPassword}
                onChange={handleChange}
                style={styleClasses.input}
              />
              {errors.currentPassword && (<p>{errors.currentPassword}</p>)}
            </div>
          </div>
          <div className="form-group" style={{ paddingBottom: "0px" }}>
            <div style={{ flex: 1 }}>
              <label htmlFor="name" style={styleClasses.label}>
                New Password <span style={{ color: "#ef4444" }}>*</span>
              </label>
              <input
                type="text"
                id="password"
                name="password"
                placeholder="Enter new password "
                value={formData.password}
                onChange={handleChange}
                style={styleClasses.input}
              />
              {errors.password && (<p style={styleClasses.error}>{errors.password}</p>)}
            </div>
          </div>
          <div className="form-group" style={{ paddingBottom: "0px" }}>
            <div style={{ flex: 1 }}>
              <label htmlFor="confirmPassword" style={styleClasses.label}>
                Confirm Password <span style={{ color: "#ef4444" }}>*</span>
              </label>
              <input
                type="text"
                id="confirmPassword"
                name="confirmPassword"
                placeholder="Retype new password"
                value={formData.confirmPassword}
                onChange={handleChange}
                style={styleClasses.input}
              />
              {errors.confirmPassword && (<p style={styleClasses.error}>{errors.confirmPassword}</p>)}
            </div>
          </div>
          <div
            style={styleClasses.buttonEndContainer}
          >
            <button
              type="submit"
              style={styleClasses.buttonSubmit }
            >
              Change Password
            </button>
          </div>
        </form>
        </div>
      </div>
    </div>
  );
}